import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.querySelectorAll( '.e-stn--dual-loop-carousel' ).forEach( initCarousel );

function cloneSlides( container, minSlides = 10 ) {
  const wrapper = container.querySelector( '.e-stn--dual-loop-carousel .swiper-wrapper' );
  const slides = wrapper.querySelectorAll( '.e-stn--dual-loop-carousel .swiper-slide' );

  if ( slides.length < minSlides ) {
    const clonesNeeded = minSlides - slides.length;
    for ( let i = 0; i < clonesNeeded; i++ ) {
      const clone = slides[i % slides.length].cloneNode( true );
      wrapper.appendChild( clone );
    }
  }
}

function initCarousel( container ) {
  const swiperParams = getSwiperParams( container );
  if ( !swiperParams ) return;

  cloneSlides( container, 15 );
  const swiper = createSwiper( container, swiperParams );
  requestAnimationFrame( () => setupAutoplayHandlers( swiper ) );
}

function getSwiperParams( container ) {
  const swiperDataEl = container.querySelector( '[data-swiper]' );
  if ( !swiperDataEl ) {
    console.warn( 'No [data-swiper] element found in container:', container );
    return null;
  }

  try {
    return JSON.parse( swiperDataEl.getAttribute( 'data-swiper' ) );
  } catch ( e ) {
    console.error( 'Invalid JSON in data-swiper attribute:', swiperDataEl, e );
    return null;
  }
}

function createSwiper( container, params ) {
  const speeds = {
    340: params?.mobile?.speed,
    768: params?.['tablet-portrait']?.speed,
    992: params?.['tablet-landscape']?.speed,
    1200: params?.desktop?.speed,
  };

  return new Swiper( container.querySelector( '.swiper' ), {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    longSwipesRatio: 0.1,
    breakpoints: {
      340: { speed: speeds[340] },
      768: { speed: speeds[768] },
      992: { speed: speeds[992] },
      1200: { speed: speeds[1200] },
    },
  } );
}

function setupAutoplayHandlers( swiper ) {
  const swiperWrapperEl = swiper.el.querySelector( '.swiper-wrapper' );
  swiperWrapperEl.style.setProperty( 'transition-timing-function', 'var(--easing)' );

  const setEasing = ( easing = 'ease' ) => {
    swiperWrapperEl.style.setProperty( '--easing', easing );
  };

  let duration;
  let startTimer;

  const stopAutoplay = () => {
    if ( startTimer ) clearTimeout( startTimer );
    swiper.setTranslate( swiper.getTranslate() );

    const currentSlideWidth = swiper.slides[swiper.activeIndex].offsetWidth;
    const distanceRatio = Math.abs(
      ( currentSlideWidth * swiper.activeIndex + swiper.getTranslate() ) / currentSlideWidth
    );

    duration = swiper.params.speed * distanceRatio;
    swiper.autoplay.stop();
  };

  const startAutoplay = ( delay = duration ) => {
    startTimer = setTimeout( () => {
      setEasing( 'linear' );
      swiper.autoplay.start();
    }, delay );
  };

  const handleTogglePlay = toggle => {
    if ( toggle === 'in' ) return stopAutoplay();

    const distance = swiper.width * swiper.activeIndex + swiper.getTranslate();
    duration = distance !== 0 ? duration : 0;
    swiper.slideTo( swiper.activeIndex, duration );

    if ( toggle === 'out' ) startAutoplay();
  };

  const debouncedToggle = debounce( handleTogglePlay, 100 );

  swiper.el.querySelectorAll( '.swiper-slide a' ).forEach( link => {
    link.addEventListener( 'pointerenter', () => debouncedToggle( 'in' ) );
    link.addEventListener( 'pointerleave', () => debouncedToggle( 'out' ) );
  } );
}

function debounce( func, delay ) {
  let timer;
  return ( ...args ) => {
    if ( timer ) clearTimeout( timer );
    timer = setTimeout( () => func( ...args ), delay );
  };
}
